import React from 'react';
import PayrollChannelFunctional from './components/payroll-channel-functional';
import './payroll-channel.scss';

const PayrollChannel = () => {
	return <PayrollChannelFunctional />;
};

export default PayrollChannel;
